import React from "react";
import { IPackage } from "pages/Packages/List/api";
import { ViewDetails } from "../../../../../components/ViewDetails";
import { StatusMessage } from "components/StatusMessage";

import "./index.css";
import { Button } from "primereact/button";
import { Message } from "primereact/message";

interface Props {
  item: IPackage;
  onRequestPickup: () => void;
  onRequestSelfDrop: () => void;
  switchingSendMode: boolean;
}

export function PendingDropoff({ item, onRequestPickup, onRequestSelfDrop, switchingSendMode }: Props) {
  const statusMessage = item.shouldSchedulePickup
    ? "We will contact you to arrange a pickup for this package"
    : "You still need to drop off this package"
  const currentSendModeInfoText = item.shouldSchedulePickup
    ? 'Pickup fee ranges from Rs.150 – Rs.480 (depending on the location). Also, items weighing up to 15kg only can be picked up at a time.'
    : 'Please note that our sellers need to pay Rs.50/kg while dropping their packages in our Self-Drop locations.'
  const currentSendModeTitleText = item.shouldSchedulePickup
    ? 'You have selected Home Pickup'
    : 'You have selected Self Drop'
  const switchSendModeButton = item.shouldSchedulePickup
    ? <Button loading={switchingSendMode} onClick={onRequestSelfDrop} className="p-button-sm p-button-outlined" label="Switch to Self Drop" />
    : <Button loading={switchingSendMode} onClick={onRequestPickup} className="p-button-sm p-button-outlined" label="Switch to Home Pickup" />
  const instructionsStep3 = item.shouldSchedulePickup
    ? null 
    : <li className="dropoff-instruction">Drop off the bag at one of our <a href="https://blog.antidotenepal.com/2023/01/12/5691" target="_blank">Drop Off Centers</a>.</li>
  const trackingMessage = item.shouldSchedulePickup
    ? <h4>You can track your package on this page after we pick it up</h4>
    : <h4>You can track your package on this page after dropping it off in one of our Drop Off Centers.</h4>

  return (
    <div>
      <StatusMessage message={statusMessage} actionType="seller"/>
      <div className="mb-4">
        <ViewDetails item={item}>
          <Message
            className="border-primary w-full p-3"
            severity="info"
            content={(
              <div>
                <div className="font-bold">{currentSendModeTitleText}</div>
                <p className="text-sm">{currentSendModeInfoText}</p>
                <div className="mt-2 not-printable">{switchSendModeButton}</div>
              </div>
            )}
          />
        </ViewDetails>
      </div>
      <hr/>
      <div className="col-12">
        <h3>Drop off Instructions</h3>
        <ol style={{paddingInlineStart:"1em"}}>
          <li className="dropoff-instruction">Keep a note inside each bag/s mentioning these details
            <ul>
              <li>Your full name (as per your citizenship card)</li>
              <li>Your contact details</li>
              <li>Your location</li>
              <li>Package code</li>
            </ul>
          </li>
          <li className="dropoff-instruction">Pack all the items inside the bag/box of your choice. Please ensure that the bags are stapled/sealed properly. If you are sending fragile items, please bubble wrap it or take ample safety measures.</li>
          {instructionsStep3}
        </ol>
        {trackingMessage}
      </div>
    </div>
  );
}
